import { styled, Grid } from "@mui/material";

export const YTDContainer = styled(Grid)({});

export const YTDS = styled(Grid)({
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",

  "& button": {
    padding: "6px 10px",
  },
});

export const FromToContainer = styled(Grid)({});

export const FromTo = styled(Grid)(({ theme }) => ({
  display: "flex",
  gap: "10px",

  ...theme.typography.body2,
  '& [role="separator"]': {
    margin: theme.spacing(0, 2),
  },

  "& .MuiFormControlLabel-root": {
    width: "100%",
  },

  "& .MuiFormLabel-root": {
    minWidth: "70px",
  },
}));

export const QuarterContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const YearPicker = styled(Grid)({
  display: "flex",
  justifyContent: "center",
  marginBottom: "10px",
  "&>div": {
    width: "unset",
  },
});

export const Quarters = styled(Grid)({
  display: "flex",
  flexWrap: "wrap",
  padding: "0 15%",
  gap: "10px",
  justifyContent: "center",
  "&>button": {
    width: "30%",
  },
});
